/**
 * How module progression gates the next module (glossary: mastery-by-content vs pool-based).
 * API JSON uses the same string values (see GET …/completion-status).
 */
export enum ModuleProgressionMode {
  ExerciseOnly = "exercise-only",
  ModuleTest = "module-test",
}

/** Maps API `progressionMode` string to enum; rejects unknown values. */
export function parseModuleProgressionMode(raw: unknown): ModuleProgressionMode {
  if (raw === ModuleProgressionMode.ExerciseOnly) {
    return ModuleProgressionMode.ExerciseOnly;
  }
  if (raw === ModuleProgressionMode.ModuleTest) {
    return ModuleProgressionMode.ModuleTest;
  }
  throw new Error(
    `Invalid progressionMode from API: ${JSON.stringify(raw)} (expected "${ModuleProgressionMode.ExerciseOnly}" or "${ModuleProgressionMode.ModuleTest}")`
  );
}

export function isPoolBasedProgression(mode: ModuleProgressionMode): boolean {
  return mode === ModuleProgressionMode.ModuleTest;
}

export function isMasteryByContentProgression(
  mode: ModuleProgressionMode
): boolean {
  return mode === ModuleProgressionMode.ExerciseOnly;
}
